import React from 'react'
import PropTypes from 'prop-types'
import {Link as RouterLink} from 'react-router-dom'
import {Box, Flex, Img, Text, useMediaQuery, useStyleConfig} from '@chakra-ui/react'
import {useCurrency} from '@salesforce/retail-react-app/app/hooks'
import {remCalc} from '../../../../../../plugins/px-to-rem-babel-custom-plugin/utils/remCalc'
import CurrentPrice from '../../../display-price/current-price'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const ProductBox = ({product, data = {}, imageClass, flexDirectionRow = false}) => {
    const styles = useStyleConfig('ProductMoodboard')

    const [isMobile] = useMediaQuery(`(max-width: ${remCalc(449)})`)
    const [isSmallTablet] = useMediaQuery(
        `(min-width: ${remCalc(450)}) and (max-width: ${remCalc(768)})`,
    )
    const viewType = isMobile || isSmallTablet ? 'small' : 'medium'

    const {currency: activeCurrency} = useCurrency()
    const {locale} = useMultiSite()

    const images = data?.imageGroups?.find((group) => group.viewType == viewType)?.images
    const image = images && images?.length > 0 ? images[0] : {}

    return (
        <Flex
            direction={flexDirectionRow ? 'row' : 'column'}
            data-testid="product-box"
            as={RouterLink}
            to={
                locale?.alias
                    ? `/${locale.alias}/p/${product?.id ? product?.id + '.html' : '#'}`
                    : '#'
            }
            {...styles.greybox}
        >
            {image?.link && (
                <Box {...styles.imagecontainer} className={'img-container'}>
                    <Img
                        src={image?.link || ''}
                        alt={image?.alt || ''}
                        className={imageClass}
                        {...styles.image}
                    />
                    <Box {...styles.imageoverlay} />
                </Box>
            )}
            <Flex w={flexDirectionRow ? '50%' : 'inherit'} {...styles.textbox}>
                {product?.id && (
                    <Text
                        {...styles.label}
                        textStyle={'body-xsmall'}
                        fontWeight={'normal'}
                        pb={remCalc(4)}
                    >
                        {product?.id}
                    </Text>
                )}
                {product?.name && (
                    <Text textStyle={'body-large'} fontWeight={'bold'} pb={remCalc(8)}>
                        {product?.name}
                    </Text>
                )}
                {product?.price && (
                    <CurrentPrice
                        price={product?.price}
                        currency={product?.currency || activeCurrency}
                        color={'text.secondary'}
                        textStyle={'body-large'}
                        fontWeight={'normal'}
                    />
                )}
            </Flex>
        </Flex>
    )
}

ProductBox.propTypes = {
    product: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        image: PropTypes.shape({
            alt: PropTypes.string,
            link: PropTypes.string,
            title: PropTypes.string,
        }),
        currency: PropTypes.string,
        price: PropTypes.number,
    }),
    data: PropTypes.shape(),
    imageClass: PropTypes.string,
    flexDirectionRow: PropTypes.bool,
}

export default ProductBox
